// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3oXfm","productName":"Table_productName__PTDwq"};